import { EstadoPedido } from '../../types/pedido';

type ColorBadge = 'ambar' | 'azul' | 'dorado' | 'verde' | 'rojo' | 'neutro';

const clasesPorColor: Record<ColorBadge, string> = {
  ambar: 'bg-[oklch(90%_0.06_65)] text-[oklch(40%_0.1_60)]',
  azul: 'bg-[oklch(88%_0.06_230)] text-[oklch(40%_0.1_240)]',
  dorado: 'bg-[oklch(90%_0.08_90)] text-[oklch(45%_0.1_85)]',
  verde: 'bg-[oklch(88%_0.09_150)] text-[oklch(40%_0.1_140)]',
  rojo: 'bg-[oklch(90%_0.07_25)] text-[oklch(45%_0.13_25)]',
  neutro: 'bg-admin-border text-admin-ink-muted',
};

export function Badge({ color = 'neutro', children }: { color?: ColorBadge; children: React.ReactNode }) {
  return (
    <span className={`inline-block rounded-full px-3 py-1 text-xs font-bold ${clasesPorColor[color]}`}>
      {children}
    </span>
  );
}

const colorPorEstado: Record<EstadoPedido, ColorBadge> = {
  PendienteDeConfirmacion: 'ambar',
  Confirmado: 'azul',
  EnProceso: 'dorado',
  Completado: 'verde',
  Cancelado: 'rojo',
};

export function EstadoPedidoBadge({ estado, etiqueta }: { estado: EstadoPedido; etiqueta: string }) {
  return <Badge color={colorPorEstado[estado]}>{etiqueta}</Badge>;
}
